import React, { useMemo } from "react";
import { Row, Col, Button } from "react-bootstrap";
import {
  FaBox,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaCar,
  FaTruck,
  FaPaperPlane,
  FaRulerCombined,
  FaWeightHanging,
  FaStar,
  FaStickyNote,
  FaRoute,
  FaClock,
  FaPallet,
  FaClipboardList,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { RouteMap } from "../../RouteMap";
import MapErrorBoundary from "../../MapErrorBoundary";
import { maskPhoneNumbers, parseCoordinates } from "../../../utils/helpers";
import "./DarkTheme.css";
import { MultiLocationMap } from "../../MultiLocationMap";
import {
  AlarmIcon,
  DeliverPointIcon,
  LeavePointIcon,
  PackageIcon,
  CalendarIcon,
  ArrowIcon,
} from "../../../assets/icons";
import { RiPinDistanceFill } from "react-icons/ri";

const DarkBookingDetailsPage = ({
  item,
  type,
  onClose,
  driver,
  setSelectedId,
  setSelectedItemForMap,
  setModalData,
  setShowModal,
}) => {
  const { t } = useTranslation();

  const fromCoords = useMemo(
    () => parseCoordinates(item.booking_from_lat_long),
    [item.booking_from_lat_long],
  );
  const toCoords = useMemo(
    () => parseCoordinates(item.booking_to_lat_long),
    [item.booking_to_lat_long],
  );

  const handleSendOfferClick = () => {
    // تنظيف السعر من التنسيق الألماني (مثلاً 1.234,56 -> 1234.56) ليعمل مع حقل number
    const rawPrice = item.discounted_price || item.price || "";
    const cleanPrice =
      typeof rawPrice === "string"
        ? rawPrice.replace(/\./g, "").replace(/,/g, ".")
        : rawPrice;

    setSelectedId(item.id);
    setSelectedItemForMap(item);
    setModalData({
      booking_id: item.id,
      driver_name: "",
      phone_number: "",
      vehicle_number: "",
      vehicle_id: "",
      vehicle_type: item.vehicle_type || "",
      current_location: driver?.postal_code || "",
      price: cleanPrice,
      driving_choice: "",
    });
    setShowModal(true);
  };

  return (
    <div className="dark-three-columns">
      {/* Section 1: Route */}
      <div className="dark-section">
        <div className="dark-section-title">
          <FaRoute />
          <span>{t("driverCard.general.route")}</span>
        </div>

        {/*  */}
        {/* <div className="mb-3 m-4">

          <div className="mb-3">
            <div className="d-flex align-items-center mb-2">
              <FaMapMarkerAlt className="text-danger me-2" />
              <strong>{t('driverCard.general.pickup')}:</strong>
            </div>
            
            {Array.isArray(item.booking_from) && item.booking_from.length > 0 ? (
              item.booking_from.map((addr, index) => {
                // استخراج التاريخ والوقت لكل نقطة تحميل
                const rawDt = item.loading_date_start
                  ? null
                  : (Array.isArray(item.loading_date_time)
                    ? item.loading_date_time[index]
                    : null) || "";
                const spaceIdx = rawDt ? rawDt.indexOf(" ") : -1;
                const dtDate = item.loading_date_start ||
                  item.loading_date ||
                  (spaceIdx > -1 ? rawDt.substring(0, spaceIdx) : rawDt) ||
                  "-";
                const dtTime = item.loading_time_start ||
                  item.loading_time ||
                  (spaceIdx > -1
                    ? rawDt.substring(spaceIdx + 1).replace(" - ", " → ")
                    : "-");
                
                return (
                  <div key={`pickup-${index}`} className="ms-3 mb-2 p-2 rounded" style={{ background: 'var(--dark-bg-primary)', borderLeft: '3px solid #ff6b00' }}>
                    <div className=" small mb-1">
                      <span className="fw-bold dark-info-label">{t('driverCard.general.pickup')} {index + 1}:</span>
                      <span className="ms-2">{addr}</span>
                    </div>
                    <div className="d-flex align-items-center column-gap-3 flex-wrap small">
                      <span>
                        <FaCalendarAlt className="me-1" size={12} />
                        {dtDate}
                        {item.loading_date_end ? ` → ${item.loading_date_end}` : ''}
                      </span>
                      <span>
                        <FaClock className="me-1" size={12} />
                        {dtTime}
                        {item.loading_time_end ? ` → ${item.loading_time_end}` : ''}
                      </span>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className=" small ms-3">
                {t('driverCard.general.notAvailable')}
              </div>
            )}
          </div>

          <div className="mb-2">
            <div className="d-flex align-items-center mb-2">
              <FaMapMarkerAlt className="text-success me-2" />
              <strong>{t('driverCard.general.delivery')}:</strong>
            </div>
            
            {Array.isArray(item.booking_to) && item.booking_to.length > 0 ? (
              item.booking_to.map((addr, index) => {
                // استخراج التاريخ والوقت لكل نقطة تنزيل
                const rawDt = item.unloading_date_start
                  ? null
                  : (Array.isArray(item.unloading_date_time)
                    ? item.unloading_date_time[index]
                    : null) || "";
                const spaceIdx = rawDt ? rawDt.indexOf(" ") : -1;
                const dtDate = item.unloading_date_start ||
                  item.unloading_date ||
                  (spaceIdx > -1 ? rawDt.substring(0, spaceIdx) : rawDt) ||
                  "-";
                const dtTime = item.unloading_time_start ||
                  item.unloading_time ||
                  (spaceIdx > -1
                    ? rawDt.substring(spaceIdx + 1).replace(" - ", " → ")
                    : "-");
                
                return (
                  <div key={`delivery-${index}`} className="ms-3 mb-2 p-2 rounded" style={{ background: 'var(--dark-bg-primary)', borderLeft: '3px solid #28a745' }}>
                    <div className=" small mb-1">
                      <span className="fw-bold dark-info-label">{t('driverCard.general.delivery')} {index + 1}:</span>
                      <span className="ms-2">{addr}</span>
                    </div>
                    <div className="d-flex align-items-center column-gap-3 flex-wrap small">
                      <span>
                        <FaCalendarAlt className="me-1" size={12} />
                        {dtDate}
                        {item.unloading_date_end ? ` → ${item.unloading_date_end}` : ''}
                      </span>
                      <span>
                        <FaClock className="me-1" size={12} />
                        {dtTime}
                        {item.unloading_time_end ? ` → ${item.unloading_time_end}` : ''}
                      </span>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className=" small ms-3">
                {t('driverCard.general.notAvailable')}
              </div>
            )}
          </div>
        </div> */}
        
        <div className="dark-section-body">
          {/* Map */}
          <div className="dark-map-wrapper">
            {fromCoords && toCoords ? (
              <RouteMap fromCoords={fromCoords} toCoords={toCoords} />
            ) : (
              <MultiLocationMap
                fromCoords={
                  Array.isArray(item?.booking_from_lat_long)
                    ? item.booking_from_lat_long
                    : Array.isArray(item?.from_lat_long)
                    ? item.from_lat_long
                    : []
                }
                toCoords={
                  Array.isArray(item?.booking_to_lat_long)
                    ? item.booking_to_lat_long
                    : Array.isArray(item?.to_lat_long)
                    ? item.to_lat_long
                    : []
                }
                key={`map-${item?.id}-${JSON.stringify(item?.booking_from_lat_long)}-${JSON.stringify(item?.booking_to_lat_long)}`}
              />
            )}
          </div>

          {/* pickup & delivery */}
          <div className="dark-route-stats py-3 justify-content-between flex-wrap">

            <div className="d-flex align-items-center gap-2">
              <FaMapMarkerAlt className="stat-icon text-danger" style={{ fontSize: "25px" }} />
              <span className="stat-label">
                {t("driverCard.general.pickup")}:
              </span>
            </div>
            <div className="dark-route-stat flex-row flex-wrap" style={{ borderBottom: '1px solid rgb(212 212 212 / 39%)' }}>
              {Array.isArray(item.booking_from) && item.booking_from.length > 0 ? (
                item.booking_from.map((addr, index) => {
                  // استخراج التاريخ والوقت لكل نقطة تحميل
                  const rawDt = item.loading_date_start
                    ? null
                    : (Array.isArray(item.loading_date_time)
                      ? item.loading_date_time[index]
                      : null) || "";

                    const spaceIdx = rawDt
                      ? rawDt.indexOf(" ")
                      : -1;
                    const dtDate =
                      item.loading_date_start ||
                      item.loading_date ||
                      (spaceIdx > -1
                        ? rawDt.substring(0, spaceIdx)
                        : rawDt) ||
                      "-";
                    const dtTime =
                      item.loading_time_start ||
                      item.loading_time ||
                      (spaceIdx > -1
                        ? rawDt
                          .substring(spaceIdx + 1)
                          .replace(" - ", " → ")
                        : "-");
                  
                  return (
                    <div key={`pickup-${index}`} className="p-2 rounded">
                      <div>
                        <span className="stat-value d-block">{addr}</span>

                        <div
                          className="p-2 d-inline-block"
                          style={{
                            backgroundColor: "inherit",
                            borderRadius: "8px",
                            // border: "1px solid rgb(212 212 212 / 39%)",
                          }}
                        >
                          <div className="d-flex align-items-center mb-1 gap-3">
                            <span
                              className="d-flex align-items-center dark-info-label small"
                              style={{ minWidth: "70px" }}
                            >
                              <FaCalendarAlt className="text-orange me-2" />{" "}
                              {t(
                                "driverCard.general.dates",
                                "Datum",
                              )}
                            </span>
                            <span className="text-dark fw-medium small flex-grow-1 text-start">
                              {dtDate}
                              {item.loading_date_end
                                ? ` → ${item.loading_date_end}`
                                : ""}
                            </span>
                          </div>
                          <div
                            className="d-flex align-items-center mt-1 pt-1 gap-3"
                            style={{
                              borderTop: "1px solid rgb(212 212 212)",
                            }}
                          >
                            <span
                              className="d-flex align-items-center dark-info-label small"
                              style={{ minWidth: "70px" }}
                            >
                              <AlarmIcon
                                className="text-orange me-2"
                                style={{ width: 16 }}
                              />{" "}

                              <span className="dark-info-label" style={{ marginLeft: "4px" }}>
                                {t(
                                  "driverCard.general.time",
                                  "Uhrzeit",
                                )}
                              </span>
                            </span>
                            <span className="text-dark fw-medium small flex-grow-1 text-start d-flex align-items-center">
                              {dtTime}
                              {item.loading_time_end
                                ? ` → ${item.loading_time_end}`
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className=" small ms-3">
                  {t('driverCard.general.notAvailable')}
                </div>
              )}
            </div>

            <div className="d-flex align-items-center gap-2 mt-4">
              <FaMapMarkerAlt className="stat-icon text-success" style={{ fontSize: "25px" }} />
              <span className="stat-label">
                {t("driverCard.general.delivery")}:
              </span>
            </div>
            <div className="dark-route-stat flex-row flex-wrap">
              {Array.isArray(item.booking_to) && item.booking_to.length > 0 ? (
                item.booking_to.map((addr, index) => {
                  // استخراج التاريخ والوقت لكل نقطة تحميل
                  const rawDt = item.unloading_date_start
                    ? null
                    : (Array.isArray(item.unloading_date_time)
                      ? item.unloading_date_time[index]
                      : null) || "";
                  const spaceIdx = rawDt
                    ? rawDt.indexOf(" ")
                    : -1;
                  const dtDate =
                    item.unloading_date_start ||
                    item.unloading_date ||
                    (spaceIdx > -1
                      ? rawDt.substring(0, spaceIdx)
                      : rawDt) ||
                    "-";
                  const dtTime =
                    item.unloading_time_start ||
                    item.unloading_time ||
                    (spaceIdx > -1
                      ? rawDt
                        .substring(spaceIdx + 1)
                        .replace(" - ", " → ")
                      : "-");
                  
                  return (
                    <div key={`delivery-${index}`} className="p-2 rounded">
                      <div className="text-center">
                        <span className="stat-value d-block">{addr}</span>
                        
                        <div
                          className="p-2 d-inline-block"
                          style={{
                            backgroundColor: "inherit",
                            borderRadius: "8px",
                            // border: "1px solid rgb(212 212 212 / 39%)",
                          }}
                        >
                          <div className="d-flex align-items-center mb-1 gap-3">
                            <span
                              className="d-flex align-items-center dark-info-label small"
                              style={{ minWidth: "70px" }}
                            >
                              <FaCalendarAlt className="text-orange me-2" />{" "}
                              {t(
                                "driverCard.general.dates",
                                "Datum",
                              )}
                            </span>
                            <span className="text-dark fw-medium small flex-grow-1 text-start">
                              {dtDate}
                              {item.unloading_date_end
                                ? ` → ${item.unloading_date_end}`
                                : ""}
                            </span>
                          </div>
                          <div
                            className="d-flex align-items-center mt-1 pt-1 gap-3"
                            style={{
                              borderTop: "1px solid rgb(212 212 212)",
                            }}
                          >
                            <span
                              className="d-flex align-items-center dark-info-label small"
                              style={{ minWidth: "70px" }}
                            >
                              <AlarmIcon
                                className="text-orange me-2"
                                style={{ width: 16 }}
                              />{" "}

                              <span className="dark-info-label" style={{ marginLeft: "4px" }}>
                                {t(
                                  "driverCard.general.time",
                                  "Uhrzeit",
                                )}
                              </span>
                            </span>
                            <span className="text-dark fw-medium small flex-grow-1 text-start d-flex align-items-center">
                              {dtTime}
                              {item.unloading_time_end
                                ? ` → ${item.unloading_time_end}`
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className=" small ms-3">
                  {t('driverCard.general.notAvailable')}
                </div>
              )}
            </div>

          </div>

          {/* Route Stats */}
          <div className="dark-route-stats justify-content-between">

            <div className="dark-route-stat gap-2 flex-row">
              <RiPinDistanceFill className="stat-icon" style={{ fontSize: "25px" }} />
              <div className="text-center">
                <span className="stat-value d-block">{(item.distance || "0 km").replace("km", " km")}</span>
                <span className="stat-label">
                  {t("driverCard.general.distance")}
                </span>
              </div>
            </div>

            <div className="dark-route-stat gap-2 flex-row">
              <FaClock className="stat-icon" style={{ fontSize: "25px" }} />
              <div className="text-center">
                <span className="stat-value d-block">{item.total_duration || "-"}</span>
                <span className="stat-label">
                  {t("driverCard.general.duration")}
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Section 2: Vehicle & Actions */}
      <div className="dark-section">
        <div className="dark-section-title">
          <FaTruck />
          <span>{t("driverCard.orderDetails.vehicleAndActions")}</span>
        </div>
        <div className="dark-section-body">
          {/* Vehicle Info */}
          <div className="dark-vehicle-info-block">
            <div className="dark-info-label">
              {t("driverCard.general.items")}
            </div>
            <div className="dark-info-value">
              <FaTruck />
              {item.vehicle_type || t("driverCard.general.notAvailable")} 
                {Number(item.vehicle_id) === 4 &&
                ` (${item.crane === "yes"
                    ? t("driverCard.general.withCrane", "Mit Hebebühne")
                    : t("driverCard.general.withoutCrane", "Ohne Hebebühne")})`}
            </div>
          </div>

          {/* CTA Button */}
          <button className="dark-btn-cta py-1" onClick={handleSendOfferClick}>
            <FaPaperPlane />
            {type === "fast"
              ? t("driverCard.buttons.sendOffer")
              : t("driverCard.buttons.makeOffer")}
          </button>

          {/* Price */}
          {item.discounted_price && (
            <div className="dark-price-block">
              <span className="dark-price-amount text-success">
                {item.discounted_price} EUR
              </span>
              <span className="dark-price-suffix">(Netto)</span>
            </div>
          )}
        </div>
      </div>

      {/* Section 3: Shipment Details */}
      <div className="dark-section">
        <div className="dark-section-title">
          <FaClipboardList />
          <span>{t("driverCard.orderDetails.shipmentDetails")}</span>
        </div>
        <div className="dark-section-body">

          {/* {(Array.isArray(item.booking_from)
            ? item.booking_from
            : [item.booking_from].filter(Boolean)
          ).map((addr, i) => {
            const rawDt = item.loading_date_start
              ? null
              : (Array.isArray(item.loading_date_time)
                ? item.loading_date_time[i]
                : null) || "";
            const spaceIdx = rawDt
              ? rawDt.indexOf(" ")
              : -1;
            const dtDate =
              item.loading_date_start ||
              item.loading_date ||
              (spaceIdx > -1
                ? rawDt.substring(0, spaceIdx)
                : rawDt) ||
              "-";
            const dtTime =
              item.loading_time_start ||
              item.loading_time ||
              (spaceIdx > -1
                ? rawDt
                  .substring(spaceIdx + 1)
                  .replace(" - ", " → ")
                : "-");
            return (
              <div key={i} className="mb-2">
                <div className="fw-bold text-orange mb-1 small">
                  {t("driverCard.general.pickup")} ({i + 1})
                </div>
                <div className="mb-1 d-flex align-items-center text-white fw-bold">
                  <FaMapMarkerAlt className="text-orange me-2 fs-5 flex-shrink-0" />
                  <span>{addr}</span>
                </div>
                <div
                  className="p-2 d-inline-block"
                  style={{
                    backgroundColor: "inherit",
                    borderRadius: "8px",
                    border: "1px solid #333",
                  }}
                >
                  <div className="d-flex align-items-center mb-1 gap-3">
                    <span
                      className="d-flex align-items-center text-muted small"
                      style={{ minWidth: "70px" }}
                    >
                      <FaCalendarAlt className="text-orange me-2" />{" "}
                      {t(
                        "driverCard.general.dates",
                        "Datum",
                      )}
                    </span>
                    <span className="text-white fw-medium small flex-grow-1 text-start">
                      {dtDate}
                      {item.loading_date_end
                        ? ` → ${item.loading_date_end}`
                        : ""}
                    </span>
                  </div>
                  <div
                    className="d-flex align-items-center mt-1 pt-1 gap-3"
                    style={{
                      borderTop: "1px solid #333",
                    }}
                  >
                    <span
                      className="d-flex align-items-center text-muted small"
                      style={{ minWidth: "70px" }}
                    >
                      <AlarmIcon
                        className="text-orange me-2"
                        style={{ width: 16 }}
                      />{" "}

                      <span className="text-muted" style={{ marginLeft: "4px" }}>
                        {t(
                          "driverCard.general.time",
                          "Uhrzeit",
                        )}
                      </span>
                    </span>
                    <span className="text-white fw-medium small flex-grow-1 text-start d-flex align-items-center">
                      {dtTime}
                      {item.loading_time_end
                        ? ` → ${item.loading_time_end}`
                        : ""}
                    </span>
                  </div>
                </div>
              </div>
            );
          })} */}

          {/* Shipment Data */}
          {item.shipment_data?.length > 0 ? (
            <>
              <div className="dark-shipment-item-row">
                <FaPallet className="dark-icon-muted" />
                <span className="">
                  {item.shipment_data.length}{" "}
                  {t("driverCard.orderDetails.shipment")}
                </span>
              </div>

              {item.shipment_data.map((s, idx) => (
                <div
                  key={idx}
                  className="dark-shipment-item-row flex-column align-items-start flex-wrap"
                  style={{ gap: "0.5rem" }}
                >
                  <div className="d-flex align-items-center gap-2 w-100">
                    <FaBox className="dark-icon-muted" />
                    <span className="">
                      {s.quantity || 1} ×{" "}
                      {t(s.shipment_data) || t("driverCard.general.notAvailable")}
                    </span>
                  </div>
                  {s.shipment_data != "dokument" && (
                    <div className="d-flex flex-wrap gap-3 ps-4">
                      <span
                        className="dark-text-muted"
                        style={{ fontSize: "0.85rem" }}
                      >
                        <FaRulerCombined className="me-1" />
                        {s.length || "0"} × {s.width || "0"} × {s.height || "0"}{" "}
                        cm
                      </span>
                      <span
                        className="dark-text-muted"
                        style={{ fontSize: "0.85rem" }}
                      >
                        <FaWeightHanging className="me-1" />
                        {s.weight || "0"} kg
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </>
          ) : (
            <p className="dark-text-muted">
              {t("driverCard.general.noShipmentData")}
            </p>
          )}

          {/* Total Weight */}
          <div className="dark-shipment-item-row mt-2 pt-2 border-bottom-0">
            <FaWeightHanging className="dark-icon-muted" />
            <span className="fw-bold">
              {t("driverCard.transportDetails.totalWeight")}:{" "}
              {item.total_weight || "0"} kg
            </span>
          </div>

          {/* Extra Services */}
          {item.extra_service && item.extra_service.length > 0 && (
            <div className="mt-3">
              <div className="dark-info-label">
                <FaStar className="me-1 dark-text-orange" />
                {t("driverCard.orderDetails.extraService")}
              </div>
              <div className="d-flex flex-wrap gap-1 mt-2">
                {Array.isArray(item.extra_service) ? (
                  item.extra_service.map((service, idx) => (
                    <span key={idx} className="dark-badge-orange">
                      {t(`${service}`)}
                    </span>
                  ))
                ) : (
                  <span className="dark-badge-orange">
                    {t(`${item.extra_service}`)}
                  </span>
                )}
              </div>
            </div>
          )}

          {/* Notes */}
          {(item.notizen || item.message) && (
            <div className="dark-notes-block">
              <label>
                <FaStickyNote className="me-1 dark-text-orange" />
                {t("driverCard.orderDetails.notes")}
              </label>
              <textarea
                className="dark-notes-textarea"
                readOnly
                value={maskPhoneNumbers(item.notizen || item.message || "")}
              />
            </div>
          )}

          {/* Close Button - Desktop only */}
          {onClose && (
            <Button
              className="w-100 py-2 fw-bold mt-3 d-md-block d-none"
              variant="outline-danger"
              onClick={onClose}
            >
              {t("driverCard.buttons.close")}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(DarkBookingDetailsPage);
